import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Table,
  Icon,
  Row,
  Col,
  Form,
  SelectPicker,
  Button,
  ControlLabel,
  Uploader,
  ButtonGroup,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import TooltipButton from '../../components/buttons/TooltipButton'
import { isEmpty } from 'lodash-es'
import CheckNoticeContents from './CheckNoticeContents'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import ReactQuillFrom from '../../components/forms/input/ReactQuill/ReactQuillFrom'
import InputForm from '../../components/forms/input/InputForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadCallBookNotice } from '../../redux/actions/checkNotice'

export default function CheckNoticeForm(props) {
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const {
    register,
    errors,
    error,
    Controller,
    control,
    setValue,
    clearErrors,
    active,
    onChangeDocType,
    onPreview,
    onDownload,
    isLoading,
  } = props

  const [formSchema, setFormSchema] = useState(props.schema.inputForm)

  const [showContents, setShowContents] = useState(false)
  const [txtContents, setTexContents] = useState(
    props?.schema?.inputForm?.detail?.value || CheckNoticeContents?.text || ''
  )
  const [docTypeValue, setDocTypeValue] = useState(props?.schema?.inputForm?.docType?.value || 0)

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const [litigationId, setIsLitigationId] = useState()
  const [litigtionNoticeId, setLitigtionNoticeId] = useState()

  const [attachFiles, setAttachFiles] = useState([])
  const [deleteFileIds, setDeleteFileIds] = useState([])

  useEffect(() => {
    if (props?.schema) {
      setLitigtionNoticeId(props?.schema?.id)
      setIsLitigationId(props?.schema?.litigationInfo?.id)
    }
    setAttachFiles(props?.schema?.inputForm?.attachFiles?.values || [])
  }, [props.schema])

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
  }

  const handleGetPdf = async () => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadCallBookNotice(litigtionNoticeId)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  const validateEditFileName = (rowData, index) => {
    return rowData.label
  }

  const onDelete = (fileObj, index) => {
    var fileIds = [...deleteFileIds]
    fileIds.push(fileObj.id)

    attachFiles.splice(index, 1)

    setAttachFiles(attachFiles)
    setDeleteFileIds(fileIds)

    setValue('deleteFileIds', fileIds)
  }

  const handlerSetValShowContents = () => {
    console.log('handlerSetValShowContents')
    if (!showContents) {
      handleGetPdf()
    }
    setShowContents(!showContents)
  }

  return (
    <>
      <Panel collapsible defaultExpanded bordered header={formSchema.header}>
        <Controller
          key={'deleteFileIds'}
          name={'deleteFileIds'}
          control={control}
          defaultValue={deleteFileIds}
        />

        <Form>
          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <span>
                <b>{formSchema.status.label}</b> : {formSchema.status.value || '-'}
              </span>
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.first._lg}
              md={twoCol.first._md}
              sm={twoCol.first._sm}
              xs={twoCol.first._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage error={errors[formSchema.docType.name]} style={{ marginBottom: 10 }} />
              <ControlLabel>
                {requiredFiled(formSchema.docType.validators, formSchema.docType.label)}
              </ControlLabel>
              <Controller
                name={formSchema.docType.name}
                control={control}
                defaultValue={formSchema.docType.value ? parseInt(formSchema.docType.value) : ''}
                rules={isValidators(formSchema.docType.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.docType.options}
                      searchable={false}
                      disabled={formSchema.docType.disabled}
                      // disabled={true}
                      value={props.value}
                      block
                      placeholder={formSchema.docType.hint || `เลือก${formSchema.docType.label}`}
                      onChange={(value) => {
                        // console.log('docc typee ', value)
                        setDocTypeValue(value)
                        onChangeDocType(value)
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          {!formSchema?.isApproveLevel && !props?.schema?.disabled && (
            <Row>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {formSchema?.attachFiles?.header}
                <Controller
                  name={'file'}
                  control={control}
                  defaultValue={undefined}
                  render={(props) => {
                    return (
                      <Uploader
                        draggable
                        autoUpload={false}
                        multiple={true}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            props.onChange(fileList)
                          }
                        }}
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
            </Row>
          )}

          {attachFiles && (
            <Row>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {formSchema?.attachFiles?.buttonText || 'ไฟล์แนบประกอบการออกหนังสือทวงถาม'}
                <Table height={300} wordWrap bordered data={attachFiles}>
                  <Column width={90} align="center" fixed>
                    <HeaderCell>ไฟล์ที่</HeaderCell>
                    <Cell>
                      {(_, index) => {
                        return index + 1
                      }}
                    </Cell>
                  </Column>
                  <Column minWidth={300} flexGrow={1}>
                    <HeaderCell>ชื่อไฟล์</HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return validateEditFileName(rowData, index)
                      }}
                    </Cell>
                  </Column>

                  <Column width={200} align="center">
                    <HeaderCell></HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return (
                          <ButtonGroup>
                            <TooltipButton
                              isStart={true}
                              icon="eye"
                              tooltip={`แสดง`}
                              disabled={isLoading}
                              onClick={(e) => onPreview(rowData)}
                            ></TooltipButton>
                            <TooltipButton
                              isStart={false}
                              icon="download"
                              tooltip={`ดาวน์โหลด`}
                              disabled={isLoading}
                              onClick={(e) => onDownload(rowData)}
                            ></TooltipButton>
                            {!props?.schema?.disabled && !formSchema?.isApproveLevel && (
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                disabled={isLoading}
                                onClick={(e) => onDelete(rowData, index)}
                              ></TooltipButton>
                            )}
                          </ButtonGroup>
                        )
                      }}
                    </Cell>
                  </Column>
                </Table>
              </Col>
            </Row>
          )}
        </Form>
      </Panel>

      <br />

      <Panel collapsible defaultExpanded bordered header={`เพิ่มรายละเอียดหนังสือทวงถาม (Notice)`}>
        <Form>
          <Row>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <Row style={{ marginBottom: 10 }}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  {/* <ControlLabel>
                    {requiredFiled(
                      formSchema.detail.validators,
                      'รายละเอียดหนังสือทวงถาม (Notice)'
                    )}
                  </ControlLabel> */}
                </Col>
                <Col lg={12} md={12} sm={12} xs={12} style={{ textAlign: 'right' }}>
                  {!showContents ? (
                    <>
                      <Button
                        appearance="ghost"
                        size="xs"
                        onClick={handlerSetValShowContents}
                        style={{ height: 32 }}
                      >
                        <Icon icon={'eye'} /> Preview
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        appearance="ghost"
                        color="red"
                        size="xs"
                        style={{ height: 32 }}
                        onClick={handlerSetValShowContents}
                      >
                        <Icon icon={'close'} /> Preview
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                {!showContents ? (
                  <>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <ReactQuillFrom
                        schema={formSchema.detail}
                        value={txtContents}
                        toolbar={[]}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        toolbars={[[]]}
                      />
                    </Col>
                  </>
                ) : (
                  <>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      {isPdfError ? (
                        <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
                      ) : (
                        <PdfRenderWidgets
                          file={previewPdf}
                          isLoading={isLoadingPDF}
                          isShaded={false}
                          onReload={() => handleGetPdf()}
                          loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF หนังสือทวงถาม (Notice)..."
                          fileName="หนังสือทวงถาม (Notice)"
                        />
                      )}
                      {/* <div dangerouslySetInnerHTML={{ __html: `${txtContents}` }} /> */}
                    </Col>
                  </>
                )}
              </Row>

              {/* <Input
                rows="5"
                componentClass="textarea"
                name={formSchema.noteOfTracking.name}
                disabled={formSchema.noteOfTracking.disabled}
                defaultValue={formSchema.noteOfTracking.value}
                placeholder={formSchema.noteOfTracking.hint}
                inputRef={register(isValidators(formSchema.noteOfTracking.validators))}
                onChange={(value) => {
                  // setTargetUnit(value)
                }}
              /> */}
            </Col>
          </Row>
        </Form>
      </Panel>

      <br />

      {formSchema?.approveComment && /*docTypeValue != 0 &&*/ formSchema?.isApproveLevel && (
        <Panel collapsible defaultExpanded bordered header={`${formSchema.approveComment.label}`}>
          {formSchema.commentInfos?.length > 0 && (
            <>
              {formSchema.commentInfos.map((item, index) => {
                return (
                  <Message
                    key={index}
                    type={'info'}
                    description={`${item.actor} : ${item.detail}`}
                  />
                )
              })}
              <br />
            </>
          )}

          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              <InputForm
                schema={formSchema.approveComment}
                rows={3}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col>
          </Row>
        </Panel>
      )}
    </>
  )
}
